import { ResultHelper } from '../helpers/ResultHelper';
import { GetDetailRequest } from '../ServerApi/requests/GetDetailRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ServerService } from '../services/ServerService';
import { IDetailFetcher } from './IDetailFetcher';

export class ServerDetailFetcher<TResource, TRequestResult extends IResult> implements IDetailFetcher<TResource> {

  constructor(
    private server: ServerService,
    private $q: ng.IQService,
    private requestMethod: string,
    private resultMapper: (result: TRequestResult) => TResource
  ) { }

  public fetchById(id: string): ng.IPromise<TResource> {
    return this.server
      .sendRequest(new GetDetailRequest<TRequestResult>(this.requestMethod, id))
      .then(ResultHelper.rejectResultOnError(this.$q))
      .then<TResource>(
        (result: TRequestResult) => this.$q.when(this.resultMapper(result)),
        (result: IResult) => this.$q.reject(result.errors && result.errors[0] && result.errors[0].code)
      );
  }

}
